
const EyeToggleIcon = ({
  visible,
  onClick,
  className = "w-5 h-5 text-white cursor-pointer",
}) => {
  return (
    <div onClick={onClick} className={className}>
      {visible ? (
        // Eye Off Icon
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path d="M1 1l22 22" />
          <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19C7.5 19 3.46 16.28 1.5 12c.86-1.72 2.11-3.26 3.66-4.45" />
          <path d="M10.59 10.59a2 2 0 0 0 2.83 2.83" />
          <path d="M15 15a5 5 0 0 1-7.07-7.07" />
          <path d="M9.88 9.88a3 3 0 0 1 4.24 4.24" />
        </svg>
      ) : (
        // Eye Icon
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      )}
    </div>
  );
};

export default EyeToggleIcon;
